import React, { useState } from "react";
import { Button, Modal, Input, Card, Spin, DatePicker } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import locale from "antd/es/date-picker/locale/fr_FR";
import { API_URL } from "../../../constants";
import { calculateTicketParking } from "../../../api/ticketParking/ticketParkingRequest";

dayjs.locale("fr");

const CalculateurTemps = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [montant, setMontant] = useState("");
  const [dateSelectionnee, setDateSelectionnee] = useState(null);
  const [resultat, setResultat] = useState(null);
  const [loading, setLoading] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setMontant("");
    setDateSelectionnee(null);
    setResultat(null);
  };

  const calculerTemps = async () => {
    if (!dateSelectionnee) {
      alert("Veuillez sélectionner une date");
      return;
    }

    setLoading(true);
    try {
     
      const data = await calculateTicketParking({
        amount: montant,
        date_debut: dateSelectionnee.format("YYYY-MM-DD HH:mm:ss"),
      });
      // const data = response.data;
      setResultat(data);
    } catch (error) {
      console.error("Erreur:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4">
      <Button type="primary" onClick={showModal}>
        Ouvrir le Calculateur
      </Button>

      <Modal
        title="Calculateur de Temps"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[
          <Button key="retour" onClick={handleCancel}>
            Retour
          </Button>,
          <Button
            key="calculer"
            type="primary"
            onClick={calculerTemps}
            loading={loading}
            disabled={!dateSelectionnee}
          >
            Calculer
          </Button>,
        ]}
      >
        <div className="space-y-4">
          <div>
            <label className="block mb-2">Date et Heure de début:</label>
            <DatePicker
              showTime={{ format: "HH:mm:ss" }}
              format="YYYY-MM-DD HH:mm:ss"
              placeholder="Sélectionnez la date et l'heure"
              onChange={setDateSelectionnee}
              value={dateSelectionnee}
              locale={locale}
              className="w-full"
            />
          </div>

          <div>
            <label className="block mb-2">Montant:</label>
            <Input
              type="number"
              value={montant}
              onChange={(e) => setMontant(e.target.value)}
              placeholder="Entrez le montant"
            />
          </div>
        </div>

        {loading && (
          <div className="text-center my-4">
            <Spin />
          </div>
        )}

        {resultat && !loading && (
          <Card title="Résultats" className="mt-4">
            <div className="space-y-2">
              <p>
                <strong>Heure de début:</strong> {resultat.start_time}
              </p>
              <p>
                <strong>Heure de sortie:</strong> {resultat.exit_time}
              </p>

              <div className="mt-4">
                <h4 className="font-bold mb-2">Temps Libre:</h4>
                <p>Jours: {resultat["InFreeTime day "]}</p>
                <p>Heures: {resultat["InFreeTime hours"]}</p>
                <p>Minutes: {resultat["InFreeTime minute"]}</p>
              </div>

              <div className="mt-4">
                <h4 className="font-bold mb-2">Temps de Travail:</h4>
                <p>Jours: {resultat["InWorkingTime day "]}</p>
                <p>Heures: {resultat["InWorkingTime hours"]}</p>
                <p>Minutes: {resultat["InWorkingTime minute"]}</p>
              </div>
            </div>
          </Card>
        )}
      </Modal>
    </div>
  );
};

export default CalculateurTemps;
